import { z } from 'zod';

import { BaseWidgetSchema } from './BaseWidgetSchema';
import { ProseMirrorJSONSchema } from './ProseMirrorJSONSchema';
import { WidgetType } from '../../utils/widgetsUtils';

export enum QuestionLayoutStyle {
  Default = 'default',
  Horizontal = 'horizontal',
  Vertical = 'vertical'
}

export enum Feedbacks {
  Automatic = 'automatic',
  Check = 'check',
  None = 'none'
}

export enum QuestionScoreMode {
  WithScore = 'withScore',
  WithoutScore = 'withoutScore'
}

export enum EvaluationMode {
  Auto = 'auto',
  Manual = 'manual'
}

export const BaseQuestionWidgetSchema = <T extends WidgetType>(widgetType: T) =>
  BaseWidgetSchema(widgetType).extend({
    evaluationMode: z.nativeEnum(EvaluationMode).optional(),
    feedback: z.nativeEnum(Feedbacks),
    /**
     * ProseMirror JSON
     */
    hintFragment: ProseMirrorJSONSchema,
    /**
     * ProseMirror JSON
     */
    instructionsFragment: ProseMirrorJSONSchema,
    /**
     * ProseMirror JSON
     */
    labelFragment: ProseMirrorJSONSchema,
    layout: z.record(
      z.string(),
      z.object({
        height: z.union([z.number(), z.string()]),
        width: z.number(),
        isDeletable: z.boolean(),
        isDraggable: z.boolean()
      })
    ),
    layoutStyle: z.nativeEnum(QuestionLayoutStyle).optional(),
    questionScoreMode: z.nativeEnum(QuestionScoreMode),
    showAnswerButton: z.boolean(),
    showFeedback: z.boolean(),
    showGeneralGrade: z.boolean().optional(),
    showHintButton: z.boolean(),
    showIndicatorButton: z.boolean(),
    showInstructions: z.boolean(),
    showHeadline: z.boolean().optional()
  });
